// extracted by mini-css-extract-plugin
module.exports = {" _key":"@dojo/widgets/breadcrumb-group","root":"breadcrumb-group-m__root__2c_G5","listItem":"breadcrumb-group-m__listItem__3N7sj"};